var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16663 17V18C9.16663 18.7956 9.4827 19.5587 10.0453 20.1213C10.6079 20.6839 11.371 21 12.1666 21C12.9623 21 13.7253 20.6839 14.2879 20.1213C14.8506 19.5587 15.1666 18.7956 15.1666 18V17M10.1666 5C10.1666 4.46957 10.3773 3.96086 10.7524 3.58579C11.1275 3.21071 11.6362 3 12.1666 3C12.6971 3 13.2058 3.21071 13.5808 3.58579C13.9559 3.96086 14.1666 4.46957 14.1666 5C15.315 5.54303 16.294 6.38833 16.9987 7.4453C17.7033 8.50227 18.1071 9.73107 18.1666 11V14C18.2419 14.6217 18.4621 15.2171 18.8094 15.7381C19.1568 16.2592 19.6217 16.6914 20.1666 17H4.16663C4.71156 16.6914 5.17644 16.2592 5.52381 15.7381C5.87119 15.2171 6.09137 14.6217 6.16663 14V11C6.22619 9.73107 6.62993 8.50227 7.33458 7.4453C8.03922 6.38833 9.01822 5.54303 10.1666 5Z",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.6f5da075fae4f72a42e7795038a6737f.svg";
export { ForwardRef as ReactComponent };